import { makeStyles } from 'tss-react/mui';
export var subHeaderStyle = makeStyles()(function (theme) { return ({
    container: {
        display: 'grid',
        gridTemplateColumns: 'repeat(7, 1fr)',
        gap: '0.5em',
        borderBottom: "4px solid #32602F",
        position: 'relative',
        '& > div': {
            width: '100%',
            margin: '0px',
        },
    },
    button: {
        backgroundColor: theme.palette.customColor.white,
        color: '#32602F',
        borderRadius: '0px',
        position: 'relative',
        bottom: 4,
        width: '100%',
        border: "1px solid #32602F",
    },
    filled: {
        backgroundColor: '#32602F',
        color: theme.palette.customColor.white,
        pointerEvents: 'none',
    },
    notification: {
        backgroundColor: theme.palette.customColor.notification,
        height: 33,
        width: 33,
        borderRadius: '50%',
        position: 'absolute',
        top: -20,
        right: -8,
    },
    incomplete: {
        borderRadius: '50%',
        backgroundColor: theme.palette.customColor.white,
        width: '21px',
        height: '21px',
        overflow: 'hidden',
        position: 'absolute',
        right: '7.5px',
        top: '7.5px',
    },
    pauseBadge: {
        position: 'absolute',
        right: 0,
        bottom: '4px',
        padding: '6px 12px',
        borderRadius: '16px',
        backgroundColor: '#FFF3E0',
        color: '#E65100',
        fontSize: '12px',
        fontWeight: 600,
        whiteSpace: 'nowrap',
        border: '1px solid #FFCC80',
        display: 'flex',
        alignItems: 'center',
        zIndex: 1,
    },
}); });
